module.exports = __webpack_public_path__ + "img/6.6863f50d.png";